import type { LoginInput } from 'src/graphql/client/generated-types';

import { Injectable } from '@angular/core';

import { SCIdentityAnswer } from '../../interfaces/auth/sc-identity-answer';
import {
  AccessLevelsGraphQL,
  IUser,
} from '../../interfaces/user/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  get userFullName(): string {
    return `${this.user?.lastName} ${this.user?.firstName}`;
  }

  get user(): IUser | undefined {
    const user = localStorage.getItem('user');
    if (!user) {
      return undefined;
    }
    return JSON.parse(user);
  }

  set user(user: IUser) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  get accessLevel(): AccessLevelsGraphQL | undefined {
    return this.user?.accessLevel;
  }

  get isAdmin(): boolean {
    return this.accessLevel === 'SECURE_CONNECT';
  }

  set userCredentials(credentials: LoginInput) {
    localStorage.setItem('credentials', JSON.stringify(credentials));
  }

  get userCredentials() {
    const credentials = localStorage.getItem('credentials');
    if (!credentials) {
      throw new Error('User is not logged in');
    }
    return JSON.parse(credentials);
  }

  get token(): SCIdentityAnswer {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('User is not logged in');
    }
    return JSON.parse(token);
  }

  set token(token: SCIdentityAnswer) {
    localStorage.setItem('token', JSON.stringify(token));
  }
}
